import api from '@/store/api'
import transform from '@/utils/transform'

const actions = {
  async getData({ dispatch }, reportKey) {
    return dispatch('setView', reportKey)
  },
  fetch(context, { catcher, params }) {
    const fetchMap = {
      creatives: () => api.getGamLicas(params).catch(catcher),
      lineitems: () => api.getGamLineItems(params).catch(catcher),
      orders: () => api.getGamOrders(params).catch(catcher),
    }
    return fetchMap[params.reportKey]()
  },
  async transform({ dispatch }, data) {
    const { columnsByKey, params } = data
    const { networkCode } = params

    const transformer = transform.freezeAll.bind(transform, networkCode, columnsByKey)

    return dispatch('tools/transformData', { data, transformer }, { root: true })
  },
  async request({ dispatch }, { moduleName = 'networks', params }) {
    const root = { root: true }
    const { reportKey } = params
    const endpointName = reportKey
    const applyFilters = moduleName === reportKey
    const requestReport = { applyFilters, endpointName, moduleName, reportKey }

    const handler = await dispatch('tools/requestHandler', requestReport, root)
    const { catcher } = handler
    const response = await dispatch('fetch', { catcher, params })

    return { ...requestReport, handler, response }
  },
  async render({ dispatch }, data) {
    const { reportKey } = data

    const results = await dispatch('transform', data)

    dispatch('messages/hideLoadingMessage', { reportKey, text: 'Rendering ...' }, { root: true })

    return results
  },
  /**
   * Get data with additional progress updates for the view.
   * @param {Object} context
   * @param {string} reportKey
   */
  async setView({ dispatch, rootGetters, rootState }, reportKey) {
    const root = { root: true }
    const moduleName = reportKey
    const columnsByKey = rootGetters['tools/columnsByKey']
    const params = rootState.tools.currentReportParams

    dispatch('messages/showLoadingMessage', { reportKey, text: 'Requesting data...' }, root)

    const requestReport = await dispatch('request', { moduleName, params })

    dispatch('messages/showLoadingMessage', { reportKey, text: 'Transforming...' }, root)

    return dispatch('render', { ...requestReport, columnsByKey, params })
  },
  openLink({ dispatch }, { item, reportKey }) {
    const { reportId, subId } = item
    const path = `/admanager/${reportKey}/${reportId}/${subId}`
    const routeName = 'admanager'
    const root = { root: true }

    dispatch('tools/updateRoute', { path, params: { reportId, reportKey, subId }, routeName }, root)
  },
  openLineItems({ dispatch }, item) {
    const reportKey = 'lineitems'
    dispatch('openLink', { item, reportKey })
  },
  openCreatives({ dispatch }, item) {
    const reportKey = 'orders'
    dispatch('openLink', { item, reportKey })
  },
}

export default actions
